import "./index.css";
import { ExpensesAndSavings } from "./ExpensesAndSavings";
import "@/lib/calculators";
import { ThemeProvider } from "./hooks/theme-provider";
import { BadgeDollarSign, Moon, Sun } from "lucide-react";
import { ThemeToggleButton } from "./components/ThemeToggleButton";
import { Separator } from "./components/ui/separator";

export function App() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="expense-app-ui-theme">
      <header className="flex w-full h-12 shrink-0 items-center justify-between gap-2 border-b transition-[width,height] ease-linear">
        <div className="flex min-w-0 items-center gap-1 px-4 lg:gap-2 lg:px-6">
          <BadgeDollarSign />
          <h1 className="text-base font-medium">Money Power</h1>
        </div>
        <ThemeToggleButton className="mx-2" />
      </header>
      <main className="container mx-auto px-4 py-6 sm:px-6 lg:px-8">
        <div className="flex flex-1 flex-col gap-2">
          <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6">
            <ExpensesAndSavings />
          </div>
        </div>
      </main>
      <footer className="w-full">
        <Separator />
        <p className="text-center text-base font-medium text-muted">
          © 2025 Luke Trouton All rights reserved.
        </p>
        <p className="text-center text-base font-medium text-muted">
          <a href="mailto:ltrouton.dev@gmail.com">Contact</a>
        </p>
      </footer>
    </ThemeProvider>
  );
}

export default App;
